<template>
  <div class="float-right">
    <b-dropdown
      size="sm"
      right
      no-caret
      variant="outline-gray-800"
    >
      <template v-slot:button-content>
        <font-awesome-icon
          :icon="faListAlt"
        />
      </template>

      <b-dropdown-form class="p-2 font-weight-normal">
        <b-form-group
          v-for="column in columns"
          :key="column.field"
          :active="column.visible"
          class="mb-1 text-capitalize"
          @submit.stop.prevent
        >
          <b-checkbox
            v-model="column.visible"
            @change="updateVisibleFields(column)"
          >
            {{ column.name }}
          </b-checkbox>
        </b-form-group>
      </b-dropdown-form>
    </b-dropdown>
  </div>
</template>

<script>
import { faListAlt } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    fields: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    faListAlt,
    columns: []
  }),
  created () {
    this.columns = this.fields
  },
  methods: {
    updateVisibleFields (column) {
      this.$emit('updateVisibleFields', column)
    }
  }
}
</script>
